import { GetStaticPaths, GetStaticProps } from 'next'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { CommunityRedirectSEO } from './RedirectsV2.page'

const RedirectsPage = () => {
  const { query } = useRouter()
  const router = useRouter()

  useEffect(() => {
    if (query.redirect) {
      router.replace(`/r/${query.redirect}`)
    }
  }, [query.redirect, router])

  return (
    <h1 className="text-3xl flex-1 flex justify-center items-center">
      <CommunityRedirectSEO
        slug={(typeof query.redirect === 'string' && query.redirect) || ''}
      />
      Hey! <br />
      Take a back seat while we are redirecting you... 🚀
    </h1>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  return { props: { ...(params || {}) } }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [
      'discord',
      'whatsapp',
      'instagram',
      'linkedin',
      'youtube',
      'twitter',
      'facebook',
      'ask',
      'pdf',
      'productdemo'
    ].map((redirect) => ({ params: { redirect } })),
    fallback: false
  }
}

export default RedirectsPage
